import { render } from "./OrderedParts.vue?vue&type=template&id=671bd66a"
import script from "./OrderedParts.vue?vue&type=script&lang=js"
export * from "./OrderedParts.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__